import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { Chip } from '../../../gql/generated/LayoutItems';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type AssetAssignedToYouBody_NotificationGroupAccessRequestApproved_Fragment = { __typename?: 'NotificationGroupAccessRequestApproved' };

export type AssetAssignedToYouBody_NotificationGroupAccessRequestDenied_Fragment = { __typename?: 'NotificationGroupAccessRequestDenied' };

export type AssetAssignedToYouBody_NotificationGroupAccessRequestSubmitted_Fragment = { __typename?: 'NotificationGroupAccessRequestSubmitted' };

export type AssetAssignedToYouBody_NotificationGroupAssetAssignedToYou_Fragment = { __typename?: 'NotificationGroupAssetAssignedToYou', content: { __typename?: 'NotificationGroupContent', layout: { __typename?: 'NotificationLayout', body?: Array<{ __typename?: 'NotificationLayoutItemAssetName' } | { __typename?: 'NotificationLayoutItemChip', content: string, style: { __typename?: 'NotificationLayoutItemStyleChip', color?: string | null } | { __typename?: 'NotificationLayoutItemStyleSection' } | { __typename?: 'NotificationLayoutItemStyleText' }, avatar?: { __typename?: 'NotificationAvatar', color?: Types.AvatarColor | null, url?: string | null, userName: string } | null } | { __typename?: 'NotificationLayoutItemProjectName' } | { __typename?: 'NotificationLayoutItemSection' } | { __typename?: 'NotificationLayoutItemShareName' } | { __typename?: 'NotificationLayoutItemText' } | { __typename?: 'NotificationLayoutItemTimestamp' } | { __typename?: 'NotificationLayoutItemUserName' }> | null } } };

export type AssetAssignedToYouBody_NotificationGroupAssetStatusChanged_Fragment = { __typename?: 'NotificationGroupAssetStatusChanged' };

export type AssetAssignedToYouBody_NotificationGroupCommentCreated_Fragment = { __typename?: 'NotificationGroupCommentCreated' };

export type AssetAssignedToYouBody_NotificationGroupCommentCreatedShareAccess_Fragment = { __typename?: 'NotificationGroupCommentCreatedShareAccess' };

export type AssetAssignedToYouBody_NotificationGroupFileUploaded_Fragment = { __typename?: 'NotificationGroupFileUploaded' };

export type AssetAssignedToYouBody_NotificationGroupReplyCreated_Fragment = { __typename?: 'NotificationGroupReplyCreated' };

export type AssetAssignedToYouBody_NotificationGroupReplyCreatedShareAccess_Fragment = { __typename?: 'NotificationGroupReplyCreatedShareAccess' };

export type AssetAssignedToYouBody_NotificationGroupRequesterAccessRequestApproved_Fragment = { __typename?: 'NotificationGroupRequesterAccessRequestApproved' };

export type AssetAssignedToYouBody_NotificationGroupRequesterAccessRequestDenied_Fragment = { __typename?: 'NotificationGroupRequesterAccessRequestDenied' };

export type AssetAssignedToYouBody_NotificationGroupTranscriptCompletedSelf_Fragment = { __typename?: 'NotificationGroupTranscriptCompletedSelf' };

export type AssetAssignedToYouBody_NotificationGroupTransferBatchCompleted_Fragment = { __typename?: 'NotificationGroupTransferBatchCompleted' };

export type AssetAssignedToYouBody_NotificationGroupTransferBatchCompletedSelf_Fragment = { __typename?: 'NotificationGroupTransferBatchCompletedSelf' };

export type AssetAssignedToYouBody_NotificationGroupUserMentioned_Fragment = { __typename?: 'NotificationGroupUserMentioned' };

export type AssetAssignedToYouBody_NotificationGroupUserMentionedShareAccess_Fragment = { __typename?: 'NotificationGroupUserMentionedShareAccess' };

export type AssetAssignedToYouBodyFragment = AssetAssignedToYouBody_NotificationGroupAccessRequestApproved_Fragment | AssetAssignedToYouBody_NotificationGroupAccessRequestDenied_Fragment | AssetAssignedToYouBody_NotificationGroupAccessRequestSubmitted_Fragment | AssetAssignedToYouBody_NotificationGroupAssetAssignedToYou_Fragment | AssetAssignedToYouBody_NotificationGroupAssetStatusChanged_Fragment | AssetAssignedToYouBody_NotificationGroupCommentCreated_Fragment | AssetAssignedToYouBody_NotificationGroupCommentCreatedShareAccess_Fragment | AssetAssignedToYouBody_NotificationGroupFileUploaded_Fragment | AssetAssignedToYouBody_NotificationGroupReplyCreated_Fragment | AssetAssignedToYouBody_NotificationGroupReplyCreatedShareAccess_Fragment | AssetAssignedToYouBody_NotificationGroupRequesterAccessRequestApproved_Fragment | AssetAssignedToYouBody_NotificationGroupRequesterAccessRequestDenied_Fragment | AssetAssignedToYouBody_NotificationGroupTranscriptCompletedSelf_Fragment | AssetAssignedToYouBody_NotificationGroupTransferBatchCompleted_Fragment | AssetAssignedToYouBody_NotificationGroupTransferBatchCompletedSelf_Fragment | AssetAssignedToYouBody_NotificationGroupUserMentioned_Fragment | AssetAssignedToYouBody_NotificationGroupUserMentionedShareAccess_Fragment;

export type AssetAssignedToYouBodyContentFragment = { __typename?: 'NotificationLayout', body?: Array<{ __typename?: 'NotificationLayoutItemAssetName' } | { __typename?: 'NotificationLayoutItemChip', content: string, style: { __typename?: 'NotificationLayoutItemStyleChip', color?: string | null } | { __typename?: 'NotificationLayoutItemStyleSection' } | { __typename?: 'NotificationLayoutItemStyleText' }, avatar?: { __typename?: 'NotificationAvatar', color?: Types.AvatarColor | null, url?: string | null, userName: string } | null } | { __typename?: 'NotificationLayoutItemProjectName' } | { __typename?: 'NotificationLayoutItemSection' } | { __typename?: 'NotificationLayoutItemShareName' } | { __typename?: 'NotificationLayoutItemText' } | { __typename?: 'NotificationLayoutItemTimestamp' } | { __typename?: 'NotificationLayoutItemUserName' }> | null };

export const AssetAssignedToYouBodyContent = /*#__PURE__*/ gql`
    fragment AssetAssignedToYouBodyContent on NotificationLayout {
  body {
    ...Chip
  }
}
    ${Chip}` as unknown as DocumentNode<AssetAssignedToYouBodyContentFragment, unknown>;
export const AssetAssignedToYouBody = /*#__PURE__*/ gql`
    fragment AssetAssignedToYouBody on NotificationGroup {
  ... on NotificationGroupAssetAssignedToYou {
    content {
      layout {
        ...AssetAssignedToYouBodyContent
      }
    }
  }
}
    ${AssetAssignedToYouBodyContent}` as unknown as DocumentNode<AssetAssignedToYouBodyFragment, unknown>;

        

        
export const useAssetAssignedToYouBodyFragment = (
  input: string | Omit<UseFragmentOptions<AssetAssignedToYouBodyFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'NotificationGroup' } };
    return input;
  })();

  return useFragment<AssetAssignedToYouBodyFragment>({
    fragment: AssetAssignedToYouBody,
    fragmentName: 'AssetAssignedToYouBody',
    ...options,
  });
};
  
        
        

        
export const useAssetAssignedToYouBodyContentFragment = (
  input: string | Omit<UseFragmentOptions<AssetAssignedToYouBodyContentFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'NotificationLayout' } };
    return input;
  })();

  return useFragment<AssetAssignedToYouBodyContentFragment>({
    fragment: AssetAssignedToYouBodyContent,
    fragmentName: 'AssetAssignedToYouBodyContent',
    ...options,
  });
};
  
        